import React from 'react';
import useStyle from './myClassCategoryButton.style';

interface MyClassCategoryButtonProps {
  title: string;
  desc: string;
  onClick: () => void;
}

export const MyClassCategoryButton = ({
  title,
  desc,
  onClick
}: MyClassCategoryButtonProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root} onClick={onClick}>
      <p className={classes.title}>{title}</p>
      <p className={classes.paragraph}>{desc}</p>
    </div>
  );
};
